<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import Swal from "sweetalert2";
import { FormWizard, TabContent } from "vue-form-wizard";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import OffersApi from "@/services/offers-api";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Ajouter une nouvelle offre",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, FormWizard, TabContent, ckeditor: CKEditor.component},

  props: {
    promotionId: {
      type: Number,
      default: 0,
    },
    suppliersOfferType:{
      type: Number,
    }
  },
  mounted() {
    this.getPromotion();
    this.getSupplierItems()
    
    this.getIsPreOrderSupplier();
  },

  data() { 
    return {
      editor: ClassicEditor,
      promotion: {},
      showForm:false,
      supplierItems:[],
      supplierPharmaItems: [],
      supplierParaItems : [],
      itemsList:[],
      paraItemsList:[],
      pharmaItemsList:[],
      selectedValue: null,
      selectedItem:null,
      isSavingOffer:false,

      isPreOrderSupplier: false,

      groupsList:[],
      selectedItemGroup: null,
      selectedPromotionItemGroup: {isMandatory: null, expirationDate: null, multiple: null, gratuity: null, discount: null},

      offerItemsPage: 0,
      offerItemsPerPage:10,

      customersFilter: null,
      clientsList: [],
      customerTableBusy: false,
      allCustomersAreSelected:null,
      editSelectionStaring:false,
      isPromotionForCustomCustomers: 0,
      pagemodelCustomersList: {currentPage : 1, perPage :10, totalRows: 0},
      customersListFields: 
                [   
                    { key:"selection",label:"",thClass:"text-center align-middle", tdClass:"text-left align-middle"},
                    { key:"name", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle ",},
                    
                    { key:"city", label: "",   sortable: false ,thClass:"text-center align-middle", tdClass:" align-middle",},
                    { key:"address", label: "",   sortable: false,thClass:"text-center align-middle", tdClass:"align-middle",},
                ],
    };
  },
    methods: {

      getPromotion(){
        var id;
        if(isNaN(this.promotionId)) id=null;
        else id =this.promotionId
        OffersApi.getPromotion(id)
        .then(response => {
          if(response) {
            this.promotion=response
            this.getItems()
          }
          else {
            this.promotion= {id:null,title:'',startDate:'',endDate:'',deliveryDays:'0',paymentDays:'0',
            minItemsNbre:'0',minOrderValue:'0',minOrderValuePara:'0',minOrderValuePharma:'0',
            description:'',isActive:false,type:'0',rules:[],items:[],cashPaymentDiscount:0}
          }
        })
      },

      getIsPreOrderSupplier(){
        OffersApi.getIsPreOrderSupplier()
        .then(response => {
          if(response) {
            this.isPreOrderSupplier=response
          }
        })
      },

      saveDetails(){
        const promise = OffersApi.saveDetails(this.promotion)
          .then(response => {
            if(response){
              this.promotion=response

              this.getCustomers();

              return true;
            }

            return false;
          })
        return promise.then(response => {return response;})
        
      },

      addRule(rules){
        rules.push({id:null,discount:'',minOrderValue:''})
      },

      deleteRule(rule){
        // this.promotion.rules.splice(index,1)
        OffersApi.deleteRule(rule,this.promotion.id)
          .then(response => {
            if(response){
              OffersApi.getPromotion(this.promotion.id)
                .then(response => {
                  if(response) {
                    this.promotion=response
                  }
                })
            }
          })

      },

      addRuleToOffer(rule){
        OffersApi.addRuleToOffer(rule,this.promotion.id)
          .then(response => {
            if(response){
                OffersApi.getPromotion(this.promotion.id)
                .then(response => {
                  if(response) {
                    this.promotion=response
                  }
                })
              
            }
          })
      },

      getSupplierItems(){
        if (this.suppliersOfferType === 1){
          OffersApi.getSupplierItems(null).then(
          response =>{
            if(response) {
              this.supplierItems=response
            }
          }
        )
        }else {
          OffersApi.getSupplierItems(1).then(
          response =>{
            if(response) {
              this.supplierParaItems=response
            }
          }
        )
          OffersApi.getSupplierItems(0).then(
          response =>{
            if(response) {
              this.supplierPharmaItems=response
            }
          }
        )

        }

        this.getAllGroups();
  
      },

      getItems(){
        if(this.suppliersOfferType===1){
          OffersApi.getItems(null,this.promotion.id)
          .then(result => {
            if(result){
              this.itemsList=result
              
            }
          })
            }
        if(this.suppliersOfferType===2){
          OffersApi.getItems(0,this.promotion.id)
          .then(result => {
            if(result){
              this.pharmaItemsList=result
              
            }
          })
          OffersApi.getItems(1,this.promotion.id)
          .then(result => {
            if(result){
              this.paraItemsList=result
              
            }
          })
            }

      },

      removeItem(item){
        OffersApi.deleteItem(item,this.promotion.id)
          .then(response => {
            if(response){
                this.getItems()
            }
          })
      },

      addToOffer(selectedItem){
        var promotionItem={id:null,itemId:selectedItem.id,gratuity:selectedItem.gratuity,isMandatory:selectedItem.isMandatory,discount:selectedItem.discount,
        multiple:selectedItem.multiple, expirationDate:selectedItem.expirationDate}
        OffersApi.addItemToOffer(promotionItem,this.promotion.id)
        .then(result=> {
          if(result){
            this.selectedItem=null
            this.getItems()
          }
        })
      },

      addGroupToOffer(groupId, selectedItemGroup){
        var promotionItem={id:null,itemId:groupId,gratuity:selectedItemGroup.gratuity,isMandatory:selectedItemGroup.isMandatory,discount:selectedItemGroup.discount,
        multiple:selectedItemGroup.multiple, expirationDate:selectedItemGroup.expirationDate}

        OffersApi.addItemGroupToOffer(promotionItem,this.promotion.id)
        .then(result=> {
          if(result){
            this.selectedItemGroup=null
            this.getItems();
          }
        })
      },

      getSelectedItemFromJson(itemId) {
        return this.supplierItems.filter(function(item) {
          return item.id == itemId;
        });
      },

      getSelectedItemParaFromJson(itemId) {
        return this.supplierParaItems.filter(function(item) {
          return item.id == itemId;
        });
      },

      getSelectedItemPharmaFromJson(itemId) {
        return this.supplierPharmaItems.filter(function(item) {
          return item.id == itemId;
        });
      },

      saveDescription(){
        this.isSavingOffer=true
      OffersApi.saveDescription(this.promotion).then(
        result =>{
          if (result) {
              this.$router.push({ name:'supplierpromotions' ,path: '/supplierpromotions', query: {activeTab: this.promotion.isActive ? 0 : 1 }})
          }
        }
      ).finally(
        this.isSavingOffer=false
      )
    },

      changeActivation(){
          Swal.fire({
            title: this.promotion.isActive ? "Retirer l'offre ?" : "Publier l'offre ?",
            html:this.promotion.isActive ?"L'offre <strong class='text-danger'> ne sera plus visible </strong> aux clients!" : "Vous <strong class='text-danger'> ne pouvez plus modifier les articles et les remises de </strong> l'offre aprés activation! "  ,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Confirmer"
        }).then(result => {
            if (result.value) {
            OffersApi.changeActivation(this.promotion).then(
            result =>{
              if (result) {
              this.$router.push({ name:'supplierpromotions' ,
                                  path: '/supplierpromotions', 
                                  query: {activeTab: !this.promotion.isApplicable && !this.promotion.isActive ? 0 : 1 }})
              }else if (result ==false) {
                this.$router.push({ name:'supplierpromotions' ,
                                    path: '/supplierpromotions', 
                                    query: {activeTab: 1 }})
              }
            }
          )
            }
        }
        )

    },

    clearSelectedItem(){
      this.selectedItem=null;
      return true
    },

    getAllGroups() {
        ItemsApi.getAllGroups(null).then(
            result => {
                this.groupsList=result;
            }
        )
      },

      getCustomers(){
            this.customerTableBusy=true
            OffersApi.getActiveCustomersWithFilter(this.customersFilter, this.promotion.id, this.pagemodelCustomersList.currentPage, this.pagemodelCustomersList.perPage).then(
                (result)=>{
                    if(result){
                        this.clientsList=result.list
                        this.pagemodelCustomersList.totalRows = result.total;
                        this.pagemodelCustomersList.currentPage = result.page;
                        this.pagemodelCustomersList.perPage = result.pageSize;
                        this.pagemodelCustomersList.pageSize = result.pageSize;
                        var addedToTraderCount=0;
                        for(const i in this.clientsList){
                            if(this.clientsList[i].isAddedToTrader==1){
                                addedToTraderCount++;
                            }  
                        }
                        if(addedToTraderCount == this.pagemodelCustomersList.pageSize ){
                            this.allCustomersAreSelected = 1
                        }else{
                            this.allCustomersAreSelected = 0
                        }
                    }
                }
            ).finally(()=>{
                this.customerTableBusy=false
            })
        },

        editSelection(item){
            
            if(item == null){
                return;
            }
            
            this.editSelectionStaring=true

            let array = [];
            array.push(item.id)
            OffersApi.editSelection(array ,this.promotion==null ? null : this.promotion.id).then(
                (result)=>{
                    if(result){
                        this.getCustomers(this.selectedUser)
                    }
                }
            ).then(
                ()=>{
                    this.editSelectionStaring=false
                }
            )
        },

        removeAllCustomers() {
          this.editSelectionStaring=true
          OffersApi.removeAllCustomers(this.promotion==null ? null : this.promotion.id).then(
                (result)=>{
                    if(result){
                        this.getCustomers(this.selectedUser)
                    }
                }
            ).then(
                ()=>{
                    this.editSelectionStaring=false
                }
            )
        }

    },


    watch: {

      isPromotionForCustomCustomers : function() {
        if (this.isPromotionForCustomCustomers == 0) {
            this.removeAllCustomers();
        }
      },

      promotion : function() {
          if (this.promotion.customersCount != 0) {
            this.isPromotionForCustomCustomers = 1;
          } else {
            this.isPromotionForCustomCustomers = 0;
          }
      },

      
       

},
  
};
</script>

<template>
  <Layout>
    <div class="row pt-4 pb-4">
      <div class="col-sm-12">
        <div class="card border border-primary" style="min-height:700px;">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-8">
                <h2 class="truncate-title card-title font-size-25" style="font-size:25px;">{{promotion.id ===null ?"Nouvelle Offre" : promotion.title}}</h2>
              </div>
              <div class="col-sm-1"/>
              <div class="col-sm-3">
                <b-button @click="changeActivation()"  style="float:right"  size="lg" :variant="promotion.isActive ? 'secondary' : 'danger'" :disabled="promotion.id===null">
                  <i class="fas fa-power-off font-size-16 align-middle mr-2"></i>{{promotion.isActive ? "Retirer l'offre" : "Publier l'offre"}} 
                </b-button>
              </div>
            </div>
            <p class="card-title-desc font-size-14">
              {{promotion.id ===null ?"Ajouter et publier une nouvelle Offre" : "Modifier l'offre"}}
            </p>
            <form-wizard @on-complete="saveDescription()" validate-on-back @on-change="clearSelectedItem" color="#5cb45b" shape="tab"
            nextButtonText="Suivant" backButtonText="Précédent" finishButtonText="Terminer">

            <div slot="finish" scope="props">
                   <b-button variant="primary" style="font-size: 14px;font-weight: 600;" :disabled="this.isSavingOffer">
                     <b-spinner small :class="this.isSavingOffer ? '' : 'd-none'"></b-spinner>
                     Terminer
                   </b-button>
            </div>
              
              <tab-content v-if="this.suppliersOfferType===2 || this.suppliersOfferType===1  " icon="fas fa-scroll" title="1. Détails de l'Offre" class="mt-3" :before-change="saveDetails">
                <div class="row">
                  <div class="col-12">

                    <div class="form-group row mb-3 ml-4 mt-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Type de l'offre</label>
                      <div class="col-md-9">

                        <b-form-radio
                        class="custom-radio custom-radio custom-radio-warning mb-3"
                        value="0"
                        v-model="promotion.type">Offre <span class="text-warning">Provisoire</span></b-form-radio> 

                        <b-form-radio
                          class="custom-radio custom-radio custom-radio-info mb-3"
                          value="1"
                          v-model="promotion.type">Offre <span class="text-info">Permanente</span></b-form-radio>  
                      </div>
                    </div>

                    <div v-if="this.isPreOrderSupplier" class="form-group row mb-3 ml-4 mt-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Objectif de l'offre</label>
                      <div class="col-md-9">

                        <b-form-radio
                          class="custom-radio custom-radio custom-radio-primary mb-3"
                          value="false"
                          v-model="promotion.isQtyTarget"><strong>Volume</strong> total de ventes</b-form-radio>  

                        <b-form-radio
                        class="custom-radio custom-radio custom-radio-primary mb-3"
                        value="true"
                        v-model="promotion.isQtyTarget"><strong>Nombre</strong> total d'unités vendues</b-form-radio> 

                      </div>
                    </div>

                    <div class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Intitulé de l'offre</label>
                      <div class="col-md-9">
                        <input type="text"  class="form-control" v-model="promotion.title"  />
                      </div>
                    </div>

                    <div class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Période de l'offre</label>
                      <div class="col-md-4">
                            <b-form-datepicker
                              v-model="promotion.startDate"
                              locale="fr"
                              label-no-date-selected="Date Début"
                              dark
                            ></b-form-datepicker>
                      </div>
                      <div class="col-md-1"/>
                      <div class="col-md-4" v-if="promotion.type==0">
                            <b-form-datepicker
                              v-model="promotion.endDate"
                              locale="fr"
                              label-no-date-selected="Date fin"
                              :min="promotion.startDate"
                              dark
                            ></b-form-datepicker>
                      </div>
                    </div>

                    <div class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Délai de Livraison (en jours)</label>
                      <div class="col-md-9">

                          <input v-model="promotion.deliveryDays"  type="number"  min="0" class="form-control"  />
                      </div>
                    </div>                    

                    <div class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" for="name">Délai de paiement (en jours)</label>
                      <div class="col-md-9">
                        <input v-model="promotion.paymentDays" type="number" min="0" class="form-control"  />
                      </div>
                    </div>

                   <div v-if="this.suppliersOfferType===1" class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" >Nombre d'unités panachables</label>
                      <div class="col-md-9">
                        <input 
                        v-model=" promotion.minItemsNbre" 
                        type="number"  
                        min="0"
                        class="form-control"  />
                      </div>
                    </div>

                    <div  v-if="this.suppliersOfferType===1" class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" >Min de Commande (TND HT)</label>
                      <div class="col-md-9">
                        <input 
                        v-model="promotion.minOrderValue" 
                        type="number"  
                        min="0"
                        class="form-control"  />
                      </div>
                    </div>

                    <div  v-if="this.suppliersOfferType===2" class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" >Min de Commande Para (TND HT)</label>
                      <div class="col-md-9">
                        <input 
                        v-model="promotion.minOrderValuePara" 
                        type="number" 
                        min="0" 
                        class="form-control"  />
                      </div>
                    </div>

                    <div  v-if="this.suppliersOfferType===2" class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" >Min de Commande Pharma (TND HT)</label>
                      <div class="col-md-9">
                        <input 
                        v-model="promotion.minOrderValuePharma" 
                        type="number"  
                        class="form-control"
                        min="0"  />
                      </div>
                    </div>

                    
                    <div  class="form-group row mb-3 ml-4">
                      <label class="col-md-3 col-form-label font-size-16" >Remise pour paiement comptant</label>
                      <div class="col-md-9">
                        <input 
                        v-model="promotion.cashPaymentDiscount" 
                        type="number"  
                        class="form-control"
                        min="0"  />
                      </div>
                    </div>

                </div>

              </div>


                  <!-- end col -->
                <!-- end row -->
              </tab-content>
              <tab-content  v-if="this.suppliersOfferType===1"   icon="fas fa-dollar-sign" title="2. Remises par Palier" class="mt-3"  >
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="font-size-16 mt-3">Remises par Palier</h3>

                    <div  class="p-4">
                      <div v-for="(rule) in this.promotion.rules" :key="rule.id"  > 
                        <div class="row"> 
                          <div class="col-sm-4">
                              <b-form-group label="Palier" label-for="">
                                <div class="input-group" style="width:350px"> 
                                    <div class="input-group-prepend">
                                      <span  class="input-group-text font-weight-bold">Montant de Commande sup à </span>
                                    </div>
                                    <input
                                      v-model="rule.minOrderValue"
                                      type="number"
                                      min="0"
                                      class="form-control text-center font-size-16"
                                      :disabled="rule.id"

                                    />
                                  </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group label="Remises" >
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="rule.discount"
                                    type="number"
                                    min="0"
                                    class="form-control font-size-16 text-center"
                                    :disabled="rule.id"
                                  />
                                  <div class="input-group-append">
                                    <span  class="input-group-text font-weight-bold font-size-16 text-primary">%</span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group v-if="!promotion.publishDate" class="text-center" label="Supprimer" >
                                <a @click="deleteRule(rule)"  href="javascript:void(0);" class="action-icon font-size-16 text-danger"><i v-b-tooltip.hover title="Retirer de l'Offre" class="fas fa-trash-alt font-size-16 text-danger mt-2"></i></a>
                              </b-form-group>
                          </div>   
                          <div v-if="!rule.id" class="col-sm-1"> 
                            <b-form-group class="text-center" label="Ajouter à l'offre" label-for="">
                              <a @click="addRuleToOffer(rule)" href="javascript:void(0);" class="action-icon font-size-20 text-info">
                                <i v-b-tooltip.hover title="Ajouter à l'offre" class="fas fa-check text-info mt-2"></i></a>
                            </b-form-group> 
                          </div>        
                        </div> 
                      </div>
                      <div class="row">
                        <div class="col-sm-9">
                        <b-button v-if="!this.promotion.publishDate" variant="link" class="mt-0 pt-0 mb-0 pb-1 pl-0 text-secondary" @click="addRule(promotion.rules)">
                          <i class="fas fa-plus font-size-16 align-middle mr-0" ></i><span class="ml-2">Ajouter un Palier</span>
                        </b-button>
                        </div>
                      </div>
                    </div>  
                  </div>
                </div>    
                <!-- end row -->
              </tab-content>

              <tab-content v-if="this.suppliersOfferType===1"  icon="fas fa-list-ol" title="3. Liste des Articles" class="mt-3" >
                <div class="row">
                  <div class="col-12">
                    <h3 class="font-size-16 mt-3">Articles concernés par l'Offre</h3> 
                    
                    






                    <!-- add to promotion by items group -->
                    <div class="row mt-3" v-if="!this.promotion.publishDate">
                        <div class="col-sm-4">
                            <b-form-group label="Ajouter un Groupe" label-for="">
                              
                              <v-select class="style-vselect" style="font-size:16px;" :options="groupsList" v-model="selectedItemGroup" placeholder="Sélectionner un groupe d'articles" label="name" >
                                  <span slot="no-options">Aucun élément dans la liste</span>
                              </v-select>   


                            </b-form-group>
                        </div>



                        
                        <div v-if="selectedItemGroup"  class="col-sm-1 ml-2">
                            <b-form-group label="Remise" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedPromotionItemGroup.discount"
                                  type="number"
                                  class="form-control p-1"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItemGroup"  class="col-sm-1">
                            <b-form-group label="Gratuités" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedPromotionItemGroup.gratuity"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>
                        <div v-if="selectedItemGroup"  class="col-sm-1">
                            <b-form-group label="Multiple" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedPromotionItemGroup.multiple"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItemGroup"  class="col-sm-2">
                            <b-form-group label="Date de péremption" label-for="">
                                <input  v-mask="'##/####'" type="text" v-model="selectedPromotionItemGroup.expirationDate" class="form-control" placeholder="Entrer une date" />
                            </b-form-group>
                        </div>

                        <div v-if="selectedItemGroup" class="col-sm-1">
                            <b-form-group class="text-center" label="Obligatoire" label-for="">
                              <b-form-checkbox
                              value="true"
                              v-model="selectedPromotionItemGroup.isMandatory"
                              class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                              checked>
                              </b-form-checkbox>
                                  </b-form-group>
                        </div>
                        <div v-if="selectedItemGroup" class="col-sm-1">
                            <b-form-group class="text-center" label="Ajouter à l'offre" label-for="">
                              <a @click="addGroupToOffer(selectedItemGroup.id, selectedPromotionItemGroup)" href="javascript:void(0);" class="action-icon font-size-20 text-info"><i v-b-tooltip.hover title="Ajouter à l'offre" class="fas fa-check text-info mt-2"></i></a>
                            </b-form-group>
                        </div>
                    </div>




                    
                    <!-- add to promotion by item -->
                    <div class="row mt-3" v-if="!this.promotion.publishDate">
                        <div class="col-sm-4">
                            <b-form-group label="Ajouter un Article" label-for="">
                              <v-select :options="supplierItems" :append-to-body="true" v-model="selectedItem" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                <span slot="no-options">Aucun élément dans la liste</span>
                              </v-select>
                            </b-form-group>
                        </div>



                        
                        <div v-if="selectedItem"  class="col-sm-1 ml-2">
                            <b-form-group label="Remise" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.discount"
                                  type="number"
                                  class="form-control p-1"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Gratuités" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.gratuity"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>
                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Multiple" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.multiple"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-2">
                            <b-form-group label="Date de péremption" label-for="">
                                <input  v-mask="'##/####'" type="text" v-model="selectedItem.expirationDate" class="form-control" placeholder="Entrer une date" />
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Obligatoire" label-for="">
                              <b-form-checkbox
                              value="true"
                              v-model="selectedItem.isMandatory"
                              class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                              checked>
                              </b-form-checkbox>
                                  </b-form-group>
                        </div>
                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Ajouter à l'offre" label-for="">
                              <a @click="addToOffer(selectedItem)" href="javascript:void(0);" class="action-icon font-size-20 text-info"><i v-b-tooltip.hover title="Ajouter à l'offre" class="fas fa-check text-info mt-2"></i></a>
                            </b-form-group>
                        </div>
                    </div>















                    <div class="row mt-4" v-if="itemsList && itemsList.length>0">
                        <div class="col-12">
                          <hr/>
                          
                          <h5>Les Articles Sélectionnés 
                            
                            <span class="text-info font-size-12">
                            
                              <a class="pl-2 pr-1 text-center" :class="offerItemsPage <= 0 ? 'd-none text-muted' : 'text-info'" @click="offerItemsPage--;"  href="javascript:void(0)" style="width:50px;">
                                  <i class="fas fa-backward text-center " ></i>   
                              </a>
                            ({{itemsList.length}} articles, Page {{offerItemsPage + 1}} sur {{Math.ceil(itemsList.length /offerItemsPerPage)}})
                              
                              <a class="pl-1 text-center" :class="offerItemsPage + 1 >= Math.ceil(itemsList.length /offerItemsPerPage) ? 'd-none text-muted' : 'text-info'" href="javascript:void(0)" @click="offerItemsPage++; " style="width:50px;">
                                <i class="fas fa-forward text-right" ></i> 
                              </a>

                            </span>

                          </h5> 
                        </div>
                        
                    </div>
                      

                      <div v-for="(item) in this.itemsList.slice(offerItemsPage * offerItemsPerPage, offerItemsPage * offerItemsPerPage + offerItemsPerPage)" :key="item.id">
                        
                        <div class="row mt-3">
                          <div class="col-sm-4">
                              <b-form-group label="Article" label-for="">
                                <v-select disabled :options="supplierItems" :value="getSelectedItemFromJson(item.itemId)" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                  <span slot="no-options">Aucun élément dans la liste</span>
                                </v-select>
                              </b-form-group>
                          </div>

                          <div class="col-sm-1 ml-2">
                              <b-form-group label="Remise" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.discount"
                                    type="number"
                                    class="form-control p-1"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group label="Gratuités" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.gratuity"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ">
                              <b-form-group label="Multiple" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.multiple"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"></i></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-2 ">
                              <b-form-group label="Date de péremption" label-for="">
                                  <input  v-mask="'##/####'" type="text" v-model="item.formattedExpirationDate" class="form-control" placeholder="" disabled/>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group class="text-center" label="Obligatoire" label-for="">
                                <b-form-checkbox
                                value="true"
                                v-model="item.isMandatory"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                                checked
                                disabled>
                                </b-form-checkbox>
                                    </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group v-if="!promotion.publishDate" class="text-center" label="Retirer de l'offre" label-for="">
                                <a @click="removeItem(item)" href="javascript:void(0);" class="action-icon font-size-16 text-danger"><i v-b-tooltip.hover title="Retirer de l'Offre" class="fas fa-trash-alt text-danger mt-2"></i></a>
                              </b-form-group>
                          </div>

                        </div>
                      </div>
                  </div>
                      <!-- end col -->
                </div>  
                <!-- end row -->
              </tab-content>

              <tab-content v-if="this.suppliersOfferType===2"  icon="fas fa-list-ol" title="2. Liste des Articles Parapharmaceutique" class="mt-3" :before-change="clearSelectedItem"  >
                <div class="row">
                  <div class="col-12">
                    <h3 class="font-size-16 mt-3">Articles Parapharmaceutiques concernés par l'Offre</h3>                    
                      <div class="row mt-3" v-if="!this.promotion.publishDate">
                        <div class="col-sm-4">
                            <b-form-group label="Tous les Articles" label-for="">
                              <v-select :options="supplierParaItems" :append-to-body="true" v-model="selectedItem" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                <span slot="no-options">Aucun élément dans la liste</span>
                              </v-select>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-1 ml-2">
                            <b-form-group label="Gratuités" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.gratuity"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Remise" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.discount"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>
                       
                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Multiple" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.multiple"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-2">
                            <b-form-group label="Date de péremption" label-for="">
                                <input  v-mask="'##/####'" type="text" v-model="selectedItem.expirationDate" class="form-control" placeholder="Entrer une date" />
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Obligatoire" label-for="">
                              <b-form-checkbox
                              value="true"
                              v-model="selectedItem.isMandatory"
                              class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                              checked>
                              </b-form-checkbox>
                                  </b-form-group>
                        </div>
                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Ajouter à l'offre" label-for="">
                              <a @click="addToOffer(selectedItem)" href="javascript:void(0);" class="action-icon font-size-20 text-info"><i v-b-tooltip.hover title="Ajouter à l'offre" class="fas fa-check text-info mt-2"></i></a>
                            </b-form-group>
                        </div>
                      </div>

                      <div v-for="(item) in this.paraItemsList" :key="item.id">
                        <div class="row mt-3">
                          <div class="col-sm-4">
                              <b-form-group label="Article" label-for="">
                                <v-select disabled :options="supplierParaItems" :value="getSelectedItemParaFromJson(item.itemId)" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                  <span slot="no-options">Aucun élément dans la liste</span>
                                </v-select>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ml-2">
                              <b-form-group label="Gratuités" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.gratuity"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ">
                              <b-form-group label="Remise" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.discount"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"></i></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ">
                              <b-form-group label="Multiple" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.multiple"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"></i></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-2 ">
                              <b-form-group label="Date de péremption" label-for="">
                                  <input  v-mask="'##/####'" type="text" v-model="item.formattedExpirationDate" class="form-control" placeholder="" disabled/>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group class="text-center" label="Obligatoire" label-for="">
                                <b-form-checkbox
                                value="true"
                                v-model="item.isMandatory"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                                checked
                                disabled>
                                </b-form-checkbox>
                                    </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group v-if="!promotion.publishDate" class="text-center" label="Retirer de l'offre" label-for="">
                                <a @click="removeItem(item)" href="javascript:void(0);" class="action-icon font-size-16 text-danger"><i v-b-tooltip.hover title="Retirer de l'Offre" class="fas fa-trash-alt text-danger mt-2"></i></a>
                              </b-form-group>
                          </div>

                        </div>
                      </div>
                  </div>
                      <!-- end col -->
                </div>  
                <!-- end row -->
              </tab-content>

              <tab-content  v-if="this.suppliersOfferType===2"  icon="fas fa-list-ol" title="3. Liste des Articles Pharmaceutique" class="mt-3" :before-change="clearSelectedItem" >
                <div class="row">
                  <div class="col-12">
                    <h3 class="font-size-16 mt-3">Articles Pharmaceutiques concernés par l'Offre</h3>                   

                      <div class="row mt-3" v-if="!this.promotion.publishDate">
                        <div class="col-sm-4">
                            <b-form-group label="Tous les Articles" label-for="">
                              <v-select :options="supplierPharmaItems" :append-to-body="true" v-model="selectedItem" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                <span slot="no-options">Aucun élément dans la liste</span>
                              </v-select>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-1 ml-2">
                            <b-form-group label="Gratuités" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.gratuity"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Remise" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.discount"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>
                       
                        <div v-if="selectedItem"  class="col-sm-1">
                            <b-form-group label="Multiple" label-for="">
                              <div class="input-group" style="width: 100px"> 
                                <input
                                  v-model="selectedItem.multiple"
                                  type="number"
                                  class="form-control"
                                  min="0"
                                />
                                <div class="input-group-append">
                                  <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"/></span>
                                </div>
                              </div>
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem"  class="col-sm-2">
                            <b-form-group label="Date de péremption" label-for="">
                                <input  v-mask="'##/####'" type="text" v-model="selectedItem.expirationDate" class="form-control" placeholder="Entrer une date" />
                            </b-form-group>
                        </div>

                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Obligatoire" label-for="">
                              <b-form-checkbox
                              value="true"
                              v-model="selectedItem.isMandatory"
                              class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                              checked>
                              </b-form-checkbox>
                                  </b-form-group>
                        </div>
                        <div v-if="selectedItem" class="col-sm-1">
                            <b-form-group class="text-center" label="Ajouter à l'offre" label-for="">
                              <a @click="addToOffer(selectedItem)" href="javascript:void(0);" class="action-icon font-size-20 text-info"><i v-b-tooltip.hover title="Ajouter à l'offre" class="fas fa-check text-info mt-2"></i></a>
                            </b-form-group>
                        </div>
                      </div>

                      <div v-for="(item) in this.pharmaItemsList" :key="item.id">
                        <div class="row mt-3">
                          <div class="col-sm-4">
                              <b-form-group label="Article" label-for="">
                                <v-select disabled :options="supplierPharmaItems" :value="getSelectedItemPharmaFromJson(item.itemId)" label="title"  class="style-vselect" style="font-size:16px;" placeholder="Sélectionner un article">
                                  <span slot="no-options">Aucun élément dans la liste</span>
                                </v-select>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ml-2">
                              <b-form-group label="Gratuités" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.gratuity"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-star text-info"/></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ">
                              <b-form-group label="Remise" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.discount"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-percentage text-info"></i></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1 ">
                              <b-form-group label="Multiple" label-for="">
                                <div class="input-group" style="width: 100px"> 
                                  <input
                                    v-model="item.multiple"
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    disabled
                                  />
                                  <div class="input-group-append">
                                    <span id="validationTooltipUsernameAppend" class="input-group-text"><i class="fas fa-times text-info"></i></span>
                                  </div>
                                </div>
                              </b-form-group>
                          </div>
                          <div class="col-sm-2 ">
                              <b-form-group label="Date de péremption" label-for="">
                                  <input  v-mask="'##/####'" type="text" v-model="item.formattedExpirationDate" class="form-control" placeholder="" disabled/>
                              </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group class="text-center" label="Obligatoire" label-for="">
                                <b-form-checkbox
                                value="true"
                                v-model="item.isMandatory"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success text-center mt-2"
                                checked
                                disabled>
                                </b-form-checkbox>
                                    </b-form-group>
                          </div>
                          <div class="col-sm-1">
                              <b-form-group v-if="!promotion.publishDate" class="text-center" label="Retirer de l'offre" label-for="">
                                <a @click="removeItem(item)" href="javascript:void(0);" class="action-icon font-size-16 text-danger"><i v-b-tooltip.hover title="Retirer de l'Offre" class="fas fa-trash-alt text-danger mt-2"></i></a>
                              </b-form-group>
                          </div>

                        </div>
                      </div>
                  </div>
                      <!-- end col -->
                </div>  
                <!-- end row -->
              </tab-content>



              <tab-content icon="mdi mdi-text" title="4. Officines" class="mt-3">
                <div class="row">
                  <div class="col-12">
                    <h3 class="font-size-16 mt-3">Officines concernées par l'Offre</h3> 
                  </div>
                </div>


                <div class="row mt-4">
                  <div class="col-12">
                    
                    <b-form-radio
                        class="custom-radio custom-radio custom-radio-primary mb-3"
                        value="0"
                        v-model="isPromotionForCustomCustomers"><span :class="isPromotionForCustomCustomers == 0 ? 'text-primary font-weight-bold' : ''">Offre visible pour toutes les officines du groupement</span></b-form-radio> 

                        <b-form-radio
                          class="custom-radio custom-radio custom-radio-primary mb-3"
                          value="1"
                          v-model="isPromotionForCustomCustomers"><span :class="isPromotionForCustomCustomers != 0 ? 'text-primary font-weight-bold' : ''">
                            <strong>Offre exclusive</strong> pour les officines sélectionnées ci-dessous</span></b-form-radio>  
                     
                 
                 
                  </div>
                </div>


               
                <div class="row mb-4 p-2 " :class="isPromotionForCustomCustomers == 0 ? 'border border-light' : 'border border-primary'"
                             style="border-radius:5px; " 
                             :style="isPromotionForCustomCustomers == 0 ? 'opacity:0.4;' : 'opacity:1;'" >
                  <div class="col-12">
                   

                    <b-form-group class="mt-2">
                      <b-input-group  >
                          <b-form-input placeholder="Chercher une officine par nom" 
                                :disabled="isPromotionForCustomCustomers == 0"
                                v-model="customersFilter"   @keyup.native.enter="getCustomers() "
                              ></b-form-input>                              
                          <template v-slot:append>
                              <b-button variant="secondary" @click="getCustomers()" >
                              <i class="bx bx-search-alt font-weight-bold font-size-16  align-middle"></i>
                              </b-button>
                          </template>
                      </b-input-group>
                    </b-form-group>
                    
                    <span v-if="!customerTableBusy & !clientsList.length" class="d-flex justify-content-center m-4 text-danger" > Aucune officine dans la liste </span>
                    <!-- <simplebar class="m-2 pt-2" style="max-height: 25em;min-height: 25em;"  > -->

                        <div class="table-responsive"  > 
                                <b-table 
                                :busy="customerTableBusy"
                                :striped="true"
                                :small="true"
                                :hover="true"
                                :items="clientsList"
                                :fields="customersListFields"
                                :perPage="pagemodelCustomersList.perPage"
                                class="table  "
                                thead-class="d-none"
                                id="my-table"
                                >
                                    <template v-slot:table-busy>
                                        <div class="text-center my-2">
                                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                        </div>
                                    </template>

                                    <template v-slot:head(companyName)>
                                        Officine
                                    </template>
                                  
                                    <template v-slot:head(city)>
                                        {{ $t("traders.tradersCustomersModal.table.city") }} 
                                    </template>

                                    <template v-slot:head(address)>
                                        Adresse
                                    </template>

                                    <!-- <template v-slot:cell(companyName)="{item, value}">
                                        <code>{{item.code}}</code> {{ value }}
                                    </template> -->

                                    <template v-slot:cell(selection)="{item}">
                                    <b-form-checkbox
                                        value="1"
                                        unchecked-value="0"
                                        class="custom-checkbox-success "
                                        v-model="item.isAddedToTrader"
                                        @input="editSelection(item)"
                                        :disabled="editSelectionStaring || isPromotionForCustomCustomers == 0"
                                        ></b-form-checkbox>
                                    </template>
                                </b-table>
                        </div>

                    <!-- </simplebar> -->

                    <!-- Pagination -->
                    <div class="row pt-0">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="getCustomers()"  v-model="pagemodelCustomersList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelCustomersList.totalRows}} officines</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelCustomersList.currentPage" :disabled="customerTableBusy" :per-page="pagemodelCustomersList.pageSize" :total-rows="pagemodelCustomersList.totalRows" @input="getCustomers()" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->

                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>



              <tab-content v-if="this.suppliersOfferType===2 || this.suppliersOfferType===1  " icon="mdi mdi-text" title="5. Description (optionnelle)" class="mt-3">
                <div class="row">
                  <div class="col-12 mt-4">
                    <h4 class="card-title mb-4">Description (Optionnelle) :</h4>
                    <!-- Editor -->
                    <ckeditor v-model="promotion.description" :editor="editor"></ckeditor>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>

             
            </form-wizard>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->


      </div>
    </div>
  </Layout>
</template>
<style>
.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>
